/**
 * 日期数量分布组件（柱状图）
 * zxw
 * 创建时间：2025-12-10
 */

import { useEffect, useRef, useMemo } from 'react';
import { Chart } from '@antv/g2';
import { Skeleton, theme, Empty } from 'antd';
import CNF from '../../../incs/Config.js';
import { NumberFormat } from '../../../incs/FunHelper.js';

const ChartIntervalTypeCount = props => {
    const { children, id, title, subtitle, streamStatus } = props;

    const {
        token: {
            isDarkMode,
        },
    } = theme.useToken();

    const chartIdRef = useRef(`${id || 'antv-g2-id'}.${Date.now()}`);
    const chartId = chartIdRef.current;

    const chartData = useMemo(() => {
        if (Array.isArray(children)) {
            return children;
        }
        if (typeof children === 'string') {
            try {
                return JSON.parse(children);
            } catch (err) {
                return [];
            }
        }
        return [];
    }, [children]);

    useEffect(() => {
        // 如果还在加载中或者没有有效数据，就不初始化图表
        if (streamStatus === 'loading') return;

        const div = document.getElementById(chartId);
        if (!div) return;
        const width = div.offsetWidth;

        const chart = new Chart({
            container: chartId,
            autoFit: true,
            height: width > 1000 ? 600 : 400,   //  全屏时高度设置为600
            theme: isDarkMode ? 'classicDark' : 'classic',
        });

        // 设置标题
        if (title) {
            chart.title({
                title: title,
                subtitle: subtitle,
            });
        }

        // 格式化数据
        chart.data(chartData);

        chart
            .interval()
            .encode('x', 'type')
            .encode('y', 'count')
            .encode('color', 'type')
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', {
                title: '类型',
            })
            .axis('y', {
                title: '数量',
                labelFormatter: (d) => NumberFormat(d),
            })
            .animate('enter', {
                type: 'scaleInY',
                duration: CNF.animateDuration,
            },)
            .tooltip({
                items: [(d => ({
                    name: '数量',
                    value: NumberFormat(d.count),
                }))]
            })
            .style('minWidth', 20)
            .style('maxWidth', 40);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, [children, streamStatus, chartId, isDarkMode]);

    // 加载时显示的骨架屏
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }

    // 数组为空，返回暂无数据
    if (chartData.length === 0) {
        return <Empty />;
    };

    return <div id={chartId} data-chart-type='true' />

}

export default ChartIntervalTypeCount;